<template>
  <tr
    :id="'tr-'+row.item.id || 0"
    :class="{'completed': getItemValue(row.item, completedField) >= $store.state.app.states.RESILIATION_STATE }"
  >
    <template v-for="(th,index) in row.headers">
      <td
        v-if="th.value === 'data-table-select'"
        class="fixed-column"
      >
        <v-checkbox
          v-model="selected"
          :disabled="getItemValue(row.item, completedField) >= $store.state.app.states.RESILIATION_STATE"
        />
      </td>
      <td
        v-else
        :id="'td-'+th.value+'-'+row.item.id || index"
        :key="th.value"
        :class="th.cellClass || ''"
        :style="{'text-align': th.align || 'left', width: th.width || '1px' }"
      >

        <slot
          :name="'item.'+th.value"
          :item="row.item"
        >
          {{ getItemValue(row.item, th.value) }}
        </slot>
      </td>
    </template>
  </tr>
</template>

<script>

// eslint-disable-next-line object-curly-newline
import {
  mdiCalendar,
  mdiCalendarRange,
  mdiFilter,
} from '@mdi/js'
import { computed, ref, watch } from '@vue/composition-api'
import { avatarText, formatDate } from '@core/utils/filter'
import { i18n } from '@/plugins/i18n'

export default {
  components: { },
  props: {
    options: {
      type: Object,
      default: () => [],
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    completedField: {
      type: String,
      default: 'state',
    },
  },
  setup(props, { emit }) {
    const today = ref((new Date(Date.now())).toISOString().substr(0, 10))
    const row = computed({
      get: () => props.options,
      set: value => emit('update:object', value),
    }, { deep: true })

    const stopNext = () => {
      console.log('parent clicked')
    }

    watch(row, val => {
      emit('update:object', val)
    }, { deep: true })
    const selected = computed({
      get: () => row.value.isSelected,
      set: value => {
        console.log(value, row.value.index)
        emit('select', { state: value, item: row.value.item, index: row.value.index })
      },
    })
    watch(selected, val => {
      // console.log(val, row.value.index)
      // emit('select', { value: val, item: row.value.item, index: row.value.index })
    }, { deep: true })

    return {
      formatDate,
      row,
      today,
      stopNext,
      selected,
      icons: {
        mdiCalendar,
        mdiCalendarRange,
        mdiFilter,
      },
    }
  },
}
</script>
